import { Alert } from "react-bootstrap";
import WidgetBase from "../common/widgetBase";
import Message from "../common/message";
import { Converter } from "../../workspace/converter";

export default class MessageNode extends WidgetBase {
  renderBody() {
    // Find messages data
    const [ messageValue, warning ] = this.loadObjectValue(
      this.props.data.component, "message", "message");

    // Find out what is the default content view
    const contentView = Converter.getComponentPortValueData(this.props.data.component, "content_view");

    // Render message content
    return (
      <>
        {warning &&
          <Alert variant="info">
            {warning}
          </Alert>
        }
        {!warning &&
          <Message
            value={messageValue}
            contentView={contentView}
          />
        }
      </>
    );
  }
}
